import axios from "axios"
const URL = `${process.env.REACT_APP_URL}/posts`

/* getAllPosts */
const getAllPosts = async (page) => {
  const { data } = await axios.get(URL)
  return data
}

/* getPost */
const getPost = async (page) => {
  const { data } = await axios.get(`${URL}?page=${page}`)
  return data
}

/* getPostById */
const getPostById = async (id) => {
  const { data } = await axios.get(`${URL}/${id}`)
  return data
}

/* getPostBySearch */
const getPostBySearch = async (searchQuery) => {
  const {
    data: { data },
  } = await axios.get(`${URL}/search/?q=${searchQuery.search}`)
  return data
}

/* createPost */
const createPost = async (postData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const { data } = await axios.post(URL, postData, config)
  return data
}

/* updatePost */
const updatePost = async (postData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const { id } = postData
  const { data } = await axios.patch(`${URL}/${id}`, postData, config)
  return data
}

/* deletePost */
const deletePost = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const { data } = await axios.delete(`${URL}/${id}`, config)
  return data
}

/* likePost */
const likePost = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const { data } = await axios.patch(`${URL}/${id}/likePost`, id, config)
  return data
}

const postService = {
  getAllPosts,
  getPost,
  getPostById,
  getPostBySearch,
  createPost,
  updatePost,
  deletePost,
  likePost,
}
export default postService
